export const normalizeHasuraTimezone = (datetime: string) => {
  if (!datetime) return datetime;

  if (!datetime.endsWith('Z')) {
    return `${datetime}Z`;
  }

  return datetime;
};
